import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

var swiper4 = new Swiper(".section4 .sec4-swiper .mySwiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: false,
  on: {
    init: function(swiper){
      $('.section4 .sec4-tab a').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section4 .sec4-tab a').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  }
});

$('.section4 .sec4-tab a').on('click',function(){
  let index = $(this).index()
  swiper4.slideTo(index)
})

$('.section1 .sec1 ul li .item-title').on('click',function(){
  if($(window).width() < 768){
    let $parents = $(this).closest('li')
    $parents.find('.item-info').fadeIn()
    $('.fixed-mask').fadeIn()
  }
})
$('.section1 .sec1 ul li .item-info .info-close').on('click',function(){
  let $parents = $(this).closest('li')
  $parents.find('.item-info').fadeOut()
  $('.fixed-mask').fadeOut()
})

let mobtab1 = 0
let mobtab2 = 0
let mobtab3 = 0

$('.section4 .sec4-swiper .slide-next').on('click',function(){
  let index = $(this).closest('.swiper-slide').index()
  console.log(index)
  if(index == 0){
    let max = $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').length - 1
    mobtab1 < max ? mobtab1 += 1 : max
    $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').css('transform','translateX(-'+ mobtab1*100 +'%)')
  }else if(index == 1){
    let max = $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').length - 1
    mobtab2 < max ? mobtab2 += 1 : max
    $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').css('transform','translateX(-'+ mobtab2*100 +'%)')
  }else if(index == 2){
    let max = $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').length - 1
    mobtab3 < max ? mobtab3 += 1 : max
    $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').css('transform','translateX(-'+ mobtab3*100 +'%)')
  }
})

$('.section4 .sec4-swiper .slide-prev').on('click',function(){
  let index = $(this).closest('.swiper-slide').index()
  console.log(index)
  if(index == 0){
    mobtab1 > 0 ? mobtab1 -= 1 : 0
    $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').css('transform','translateX(-'+ mobtab1*100 +'%)')
  }else if(index == 1){
    mobtab2 > 0 ? mobtab2 -= 1 : 0
    $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').css('transform','translateX(-'+ mobtab2*100 +'%)')
  }else if(index == 2){
    mobtab3 > 0 ? mobtab3 -= 1 : 0
    $('.section4 .sec4-swiper .swiper-slide').eq(index).find('li').css('transform','translateX(-'+ mobtab3*100 +'%)')
  }
})